export default {"src":"/_next/static/media/warning_64.bfa70432.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};